/* NEXT SCIENCE guide events v1. No page_view, purchase or generate_lead is emitted. */
(function () {
  'use strict';
  if (window.__nsGuideEventsInstalled) return;
  window.__nsGuideEventsInstalled = true;
  function allowed() {
    try {
      return !((window.Shopify || {}).designMode) && !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed && Shopify.customerPrivacy.analyticsProcessingAllowed() === true);
    } catch (_) { return false; }
  }
  function clean(value) { return String(value || '').replace(/[^a-zA-Z0-9_:\/-]/g, '').slice(0, 100); }
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest || event.button > 0 || event.isTrusted === false) return;
    var link = target.closest('a[data-ns-guide-link]');
    if (!link || !allowed()) return;
    var url;
    try { url = new URL(link.href, window.location.href); } catch (_) { return; }
    if (url.origin !== window.location.origin) return;
    var wrapper = link.closest('[data-ns-guide-context]');
    var data = {
      guide_version: '20260908',
      guide_context: clean(wrapper && wrapper.getAttribute('data-ns-guide-context')),
      guide_action: clean(link.getAttribute('data-ns-guide-link')),
      source_path: window.location.pathname.slice(0, 300),
      destination_path: url.pathname.slice(0, 300)
    };
    try {
      if (Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        var result = Shopify.analytics.publish('ns:guide_click', data);
        if (result && typeof result.catch === 'function') result.catch(function () {});
      }
    } catch (_) { /* Navigation must work even when analytics is unavailable. */ }
  }, true);
})();
